import {Component} from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-switch-boolean-field',
  templateUrl: './gelios-switch-boolean-field.component.html',
  styleUrls: ['./gelios-switch-boolean-field.component.scss']
})
export class GeliosSwitchBooleanFieldComponent extends GeliosFieldBaseComponent {
  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }
}

